<template>
  <div class="batch-tools-page">
    <header class="page-header">
      <div>
        <router-link :to="`/projects/${projectId}`" class="back-link">← Project</router-link>
        <h1>Batch tools</h1>
        <p class="page-sub">Secure intake links and bulk reprocess for this project.</p>
      </div>
    </header>

    <section id="intake" class="tool-section">
      <BatchIntakeManager :project-id="Number(projectId)" />
    </section>

    <section id="email-intake" class="tool-section">
      <InboundCertificateQueue :project-id="Number(projectId)" />
    </section>

    <section id="reprocess" class="tool-section">
      <BatchProcessingManager :project-id="Number(projectId)" />
    </section>
  </div>
</template>

<script>
import BatchIntakeManager from '@/components/batch/BatchIntakeManager.vue';
import BatchProcessingManager from '@/components/batch/BatchProcessingManager.vue';
import InboundCertificateQueue from '@/components/batch/InboundCertificateQueue.vue';

export default {
  name: 'ProjectBatchTools',
  components: { BatchIntakeManager, BatchProcessingManager, InboundCertificateQueue },
  props: {
    projectId: { type: [String, Number], required: true },
  },
  mounted() {
    if (this.$route.hash) {
      this.$nextTick(() => {
        const el = document.querySelector(this.$route.hash);
        el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  },
};
</script>

<style scoped>
.batch-tools-page {
  max-width: 1120px;
  margin: 0;
}

.page-header {
  margin-bottom: 1.25rem;
}

.page-header h1 {
  margin: 0.25rem 0 0.2rem;
  font-size: 1.75rem;
  font-weight: 700;
  color: #0f172a;
}

.page-sub {
  margin: 0;
  color: #475569;
  font-size: 0.95rem;
}

.back-link {
  font-size: 0.875rem;
  color: #475569;
  text-decoration: none;
}

.back-link:hover {
  color: var(--p-accent, #1e3a5f);
}

.tool-section {
  margin-bottom: 1.5rem;
}
</style>
